export default __webpack_public_path__ + "static/media/wics.2172434d.png";